export default __webpack_public_path__ + "static/media/example1.9bfc5a33.png";